export default __webpack_public_path__ + "static/about-6aaff592b2d4688f4a394149fd0ecaab.jpg";